export default {"src":"/_next/static/media/email.dca0b339.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};